import React from 'react';

// Label de capítulo da home — 11px/.14em/uppercase lavanda + hairline acima
// (o traço do atlas). Opcionalmente animada no primeiro scroll (reveal único).
interface ChapterLabelProps {
  children: React.ReactNode;
  align?: 'left' | 'center';
}

export const ChapterLabel: React.FC<ChapterLabelProps> = ({ children, align = 'left' }) => {
  return (
    <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <span className="h-px flex-1 bg-stela-line" aria-hidden="true" />
      <span className="text-label tracking-[.14em] uppercase font-semibold text-stela-muted whitespace-nowrap">
        {children}
      </span>
      <span className="h-px flex-1 bg-stela-line" aria-hidden="true" />
    </div>
  );
};